import { categoryLabel, categoryPillStyle } from '../lib/reply-taxonomy';

/** A reply-category tag, colored by attention level. */
export function CategoryPill({ category }: { category: string }): JSX.Element {
  return (
    <span className="pill" style={categoryPillStyle(category)}>
      <span className="pdot" />
      {categoryLabel(category)}
    </span>
  );
}
